import styled from '@emotion/styled'

export const Typography = styled.div`
  font-family: 'Noto Sans JP', 'Helvetica Neue', Helvetica, 'Hiragino Sans',
    'ヒラギノ角ゴ ProN W3', 'Hiragino Kaku Gothic ProN', メイリオ, Meiryo;
`